import * as React from "react";
import { IconWrapper } from "common/icons";
import PACKS from "app/common/icons/packs";

const styles = require("./followButton.scss");

interface IProps {
  isFollowing: boolean;
  onFollowClick: () => void;
  forCommunity: boolean;
}

const SimpleFollowButton = ({
  isFollowing,
  onFollowClick,
  forCommunity,
}: IProps) => {
  let icon;
  if (isFollowing) {
    icon = forCommunity
      ? PACKS.INTEREST_SHOW.HEADER.COMMUNITY_UNFOLLOW_BUTTON
      : PACKS.INTEREST_SHOW.HEADER.HASHTAG_UNFOLLOW_BUTTON;
  } else {
    icon = forCommunity
      ? PACKS.INTEREST_SHOW.HEADER.COMMUNITY_FOLLOW_BUTTON
      : PACKS.INTEREST_SHOW.HEADER.HASHTAG_FOLLOW_BUTTON;
  }

  return (
    <IconWrapper
      onClick={onFollowClick}
      icon={icon}
      className={styles.button}
    />
  );
};

export default SimpleFollowButton;
